import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Actions } from '~/store/auth/actions';

const SessionVerification = ({ children }: React.PropsWithChildren) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Actions.VERIFY_REQUEST());
  }, []);
  return <>{children}</>;
};

export default SessionVerification;
